// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0fbba3ad","455":"2f21b311","977":"f288c87d"}[chunkId] + ".chunk.js";
};